import React, { Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { LoanBaseLayout, LoanStepsLayout } from '../pages/loan/ui/layout/loan.layout';

const LoanDetailsPage = React.lazy(() => import('../pages/loan/ui/steps/details/loan-details'));
const Identity = React.lazy(() => import('../pages/loan/ui/steps/identity/identity'));
const Documents = React.lazy(() => import('../pages/loan/ui/steps/documents/documents'));
const Confirmation = React.lazy(() => import('../pages/loan/ui/steps/confirmation/confirmation'));
const LoanCompleted = React.lazy(() => import('../pages/loan/ui/steps/completed/completed'));

const loan_routes: RouteObject[] = [
  {
    path: '/:lang/loan/order',
    element: <LoanBaseLayout />,
    children: [
      {
        element: <LoanStepsLayout />,
        children: [
          {
            path: 'details',
            element: <LoanDetailsPage />,
          },
          {
            path: 'identity',
            element: <Identity />,
          },
          {
            path: 'documents',
            element: <Documents />,
          },
          {
            path: 'confirmation',
            element: <Confirmation />,
          },
        ],
      },
      {
        path: 'completed',
        element: (
          <Suspense fallback={null}>
            <LoanCompleted />
          </Suspense>
        ),
      },
    ],
  },
];

export default loan_routes;
